import { handleActions } from 'redux-actions';
import { actions } from '../../actions/customCards';
export const { getCustomCardById, getCustomCardByIdSucceeded, getCustomCardByIdFailed, testCustomCard, testCustomCardSucceeded, testCustomCardFailed, resetCustomCard, } = actions;
export function emptyCard() {
    return {
        card_type: 'custom',
        hook: {
            title: '',
            hook_id: '',
            headers: null,
            uri_template: '',
        },
        template: '',
    };
}
const initialState = {
    cards: [],
    currentCard: emptyCard(),
    testResult: null,
    meta: null,
};
// Reducer
export const customCards = handleActions({
    [getCustomCardById.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'loading' }) });
    },
    [getCustomCardByIdSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { currentCard: action.payload.data, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'succeeded' }) });
    },
    [getCustomCardByIdFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'failed' }) });
    },
    [testCustomCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'loading' }), testResult: null });
    },
    [testCustomCardSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'succeeded' }), testResult: Object.assign({}, action.payload.data) });
    },
    [testCustomCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'failed' }) });
    },
    [resetCustomCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { currentCard: emptyCard(), testResult: null, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: null }) });
    },
}, initialState);
